
/*
doPSOStateTerritoryRule
hideProviderProfile
doHospProvidersRule


function enableNumberField(questionCode, selectedCheckbox){
    for (var i=0; selectedCheckbox != null && i<selectedCheckbox.length; i++) {
        getElement(questionCode+selectedCheckbox[i]+'number').disabled = false;
    }
}

function enableOtherTextField(questionCode, selectedCheckbox){
    for (var i=0; selectedCheckbox != null && i<selectedCheckbox.length; i++) {
        if(selectedCheckbox[i] == 'C012' || selectedCheckbox[i] == 'C199'){
            getElement(questionCode+selectedCheckbox[i]+'txt').disabled = false;
        }
    }
}*/
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',
    SET_INITIAL_DATA: 'set-data',
    ADD_QUESTION: 'add-question',
    ADD_ANSWER: 'add-answer',

    UPDATE_QUESTION: 'update-question',
    UPDATE_ANSWER: 'update-answer',
    CLEAR_QUESTION_ANSWERS: 'clear-question-answers'
}

export function doPSOProviderRule(pso30, pso30_1, pso31, pso31_1, setShowProvSection, dispatch, pageType) {
    var show = false;

    //console.log("PSO30 Val" + pso30.value);
    //console.log(pso30.value > 0);
    //console.log(pso30.value=="");
    //console.log(pso30.value==null);
    //console.log(Number(pso30.value));
    //console.log(isNaN(pso30.value));

    //(question.questionCode=="pso30.1" && section.questions[subSection]['pso30']!=0) || (question.questionCode=="pso31.1" && section.questions[subSection]['pso31']!=0)
    
    

    if((pso30.value != null && pso30.value != 0 ) || pso30.checked==true || pso30.value==''){
        
        if(pso30.checked != true  && pso30.value>0){
            show = true;
        }

        for(var x = 0 ; x<pso30_1.answers.length ; x++){
            var ans = pso30_1.answers[x];
            if(ans.disabled!=true){
                dispatch({
                    type: ACTIONS.UPDATE_ANSWER,
                    questionId: pso30_1.id,
                    questionCode: pso30_1.questionCode,
                    subSection: "participatingProviders",
                    answerCode: ans.answerCode,
                    checked: false,
                    disabled: true,
                    isInvalid: false,
                    errors:[],
                    pageType: pageType
                }); 
            }
            
        }

        if(pso30_1.visible == true){
            dispatch({
                type: ACTIONS.UPDATE_QUESTION,
                questionId: pso30_1.id,
                questionCode: pso30_1.questionCode,
                subSection: "participatingProviders",
                visible: false,
                pageType: pageType
            }); 
        }
        
    }
    else{
        for(var x = 0 ; x<pso30_1.answers.length ; x++){
            var ans = pso30_1.answers[x];
            if(ans.disabled!=false){
                dispatch({
                    type: ACTIONS.UPDATE_ANSWER,
                    questionId: pso30_1.id,
                    questionCode: pso30_1.questionCode,
                    subSection: "participatingProviders",
                    answerCode: ans.answerCode,
                    disabled: false,
                    isInvalid: false,
                    errors:[],
                    pageType: pageType
                }); 
            }
            
        }
        if(pso30.value != null && pso30.value == 0){
            //console.log("PSO30VALSTUFF " + pso30.value);
            //console.log(pso30_1.visible);
            if(pso30_1.visible == false){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso30_1.id,
                    questionCode: pso30_1.questionCode,
                    subSection: "participatingProviders",
                    visible: true,
                    pageType: pageType
                }); 
            }
            
        }
        else{
            //console.log("PSO30_1VALSTUFF" + pso30.value);
            if(pso30_1.visible == true){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso30_1.id,
                    questionCode: pso30_1.questionCode,
                    subSection: "participatingProviders",
                    visible: false,
                    pageType: pageType
                }); 
            }
            
        }
        
    }


    if((pso31.value != null && pso31.value != 0) || pso31.checked==true  || pso31.value==''){
        if(pso31.checked != true && pso31.value>0){
            show = true;
        }

        for(var x = 0 ; x<pso31_1.answers.length ; x++){
            var ans = pso31_1.answers[x];
            if(ans.disabled!=true){
                 dispatch({
                    type: ACTIONS.UPDATE_ANSWER,
                    questionId: pso31_1.id,
                    questionCode: pso31_1.questionCode,
                    subSection: "participatingProviders",
                    answerCode: ans.answerCode,
                    checked: false,
                    disabled: true,
                    isInvalid: false,
                    errors:[],
                    pageType: pageType
                }); 
            }
           
        }

        if(pso31_1.visible == true){
            dispatch({
                type: ACTIONS.UPDATE_QUESTION,
                questionId: pso31_1.id,
                questionCode: pso31_1.questionCode,
                subSection: "participatingProviders",
                visible: false,
                pageType: pageType
            }); 
        }
    }
    else{
        for(var x = 0 ; x<pso31_1.answers.length ; x++){
            var ans = pso31_1.answers[x];
            if(ans.disabled!=false){
                dispatch({
                    type: ACTIONS.UPDATE_ANSWER,
                    questionId: pso31_1.id,
                    questionCode: pso31_1.questionCode,
                    subSection: "participatingProviders",
                    answerCode: ans.answerCode,
                    disabled: false,
                    isInvalid: false,
                    errors:[],
                    pageType: pageType
                }); 
            }
            
        }

        if(pso31.value != null && pso31.value == 0){
            if(pso31_1.visible == false){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso31_1.id,
                    questionCode: pso31_1.questionCode,
                    subSection: "participatingProviders",
                    visible: true,
                    pageType: pageType
                });
            }
             
        }
        else{
            if(pso31_1.visible == true){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso31_1.id,
                    questionCode: pso31_1.questionCode,
                    subSection: "participatingProviders",
                    visible: false,
                    pageType: pageType
                }); 
            }
            
        }
    }
    
    //setShowProvSection(true); //TODO
    setShowProvSection(show);
}


export function doOldProviderRule(pso04, pso25, pso24, dispatch, pageType) {
    
    if(pso04.value != null){
        
        if(pso04.value == -1 ){
            if(pso25.visible == true){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso25.id,
                    questionCode: pso25.questionCode,
                    subSection: "participatingProviders",
                    visible: false,
                    pageType: pageType
                }); 
            }
            
            if(pso24.visible == true){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso24.id,
                    questionCode: pso24.questionCode,
                    subSection: "participatingProviders",
                    visible: false,
                    pageType: pageType
                }); 
            }
            
        }
        else{
            if(pso25.visible == false){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso25.id,
                    questionCode: pso25.questionCode,
                    subSection: "participatingProviders",
                    visible: true,
                    pageType: pageType
                }); 
            }
            
            if(pso24.visible == false){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso24.id,
                    questionCode: pso24.questionCode,
                    subSection: "participatingProviders",
                    visible: true,
                    pageType: pageType
                }); 
            }
        }

        
    }


}

export function doPSOSpecialtiesRule(pso21, pso28, dispatch, pageType) {

    //console.log("PSO21 Val" + pso21.value);
    //console.log("PSO28 Val" + pso28.value);

    if((pso28.answers).find(a => a.answerCode === "C019").checked != true ){
        if(pso21.visible==true){
            dispatch({
                type: ACTIONS.UPDATE_QUESTION,
                questionId: pso21.id,
                questionCode: pso21.questionCode,
                subSection: "psoCharacteristics",
                visible: false,
                value: "",
                checked: false,
                isInvalid: false,
                errors:[],
                pageType: pageType
            }); 

        }
    } 
    else{
        if(pso21.visible==false){
            dispatch({
                type: ACTIONS.UPDATE_QUESTION,
                questionId: pso21.id,
                questionCode: pso21.questionCode,
                subSection: "psoCharacteristics",
                visible: true,
                pageType: pageType
                //isInvalid: false,
                //errors:[]
            }); 
        }
    }     
}

export function doPSOStateTerritoryRule(pso14, pso26, dispatch, reportYear, pageType) {
    var show = false;

    //console.log(reportYear);
    //console.log(reportYear>2019);

    //console.log("PSO14 Val" + pso14.value);
    //console.log("PSO26 Val" + pso26.value);

    var c196 = (pso14.answers).find(a => a.answerCode === "C196");
    var c195 = (pso14.answers).find(a => a.answerCode === "C195");
    
    var c055 = (pso14.answers).find(a => a.answerCode === "C055");
    var c057 = (pso14.answers).find(a => a.answerCode === "C057");
  
    if(reportYear>2019){
        if(c195!=null && c196!=null && (c195.checked == true || c196.checked == true )){
            if(pso26.visible!=true){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso26.id,
                    questionCode: pso26.questionCode,
                    subSection: "psoCharacteristics",
                    visible: true,
                    pageType: pageType
                }); 
            }
        }
        else if(c057!=null && (c057.checked == true )){
            if(pso26.visible!=true){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso26.id,
                    questionCode: pso26.questionCode,
                    subSection: "psoCharacteristics",
                    visible: true,
                    pageType: pageType
                }); 
            }
        }
        else{
            if(pso26.visible!=false){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso26.id,
                    questionCode: pso26.questionCode,
                    subSection: "psoCharacteristics",
                    visible: false,
                    pageType: pageType
                }); 
            }
        }  
    }
    else{
        //if(c057!=null && (c057.checked == true )){
            if(pso26.visible!=true){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso26.id,
                    questionCode: pso26.questionCode,
                    subSection: "psoCharacteristics",
                    visible: true,
                    pageType: pageType
                }); 
            }
       // }
        /*else{
            if(pso26.visible!=false){
                dispatch({
                    type: ACTIONS.UPDATE_QUESTION,
                    questionId: pso26.id,
                    questionCode: pso26.questionCode,
                    subSection: "psoCharacteristics",
                    visible: false
                }); 
            }
        }  */
    }
       
}

/*
        
        
        
        



function addClass (propClasses, className) {
    var classes = "";
    if(propClasses != null){
        var arr = propClasses.split(" ").map(function(value) {
            return value.trim();
        });
        var isIncluded = arr.includes(className.trim());
        if(isIncluded){
            classes = propClasses;
        }
        else{
            classes = propClasses.concat(" " + className);
        }
    }
    else{
        classes = className;
    }

    return classes;
}

export const TextButton = (props) => {
    var classes = addClass(props.className,"text-button");

    return (
        <Button {...props} className={classes}>
            <div>{props.content}</div>
        </Button>
    )
}

export const IconTextButton = (props) => {
    var classes = addClass(props.className,"icon-text-button");

    return (
        <Button {...props} className={classes}>
          <Stack direction="horizontal" gap={2}>
            <div className="buttonIcon">
              {props.icon()}
            </div>
            <div className="buttonText">
              <>{props.content}</>
            </div>
          </Stack>
        </Button>
    )
}

export const IconButton = (props) => {
    var classes = addClass(props.className,"icon-button");

    return (
        <Button {...props} className={classes}>
            <div className="buttonIcon">
              {props.icon()}
            </div>
        </Button>
    )
}


export const BackToTopButton = (props) => {
    var classes = addClass(props.className,"back-to-top-button");
    var allClasses = classes + " " + props.fadeClass;
    return (
        <Button variant={props.variant} onClick={props.onClick} className={allClasses}>
          <Stack direction="horizontal" gap={2}>
            <div className="buttonText">
              <>{props.content}</>
            </div>
            <div className="buttonIcon">
              {props.icon()}
            </div>
          </Stack>
        </Button>
    )
}

export const NotificationButton = (props) => {
    var classes = addClass(props.className,"notification-button");

    return (
        <Button {...props} className={classes} aria-label="Notifications" title="Notifications" >
            <div className="notificationDot">

            </div>
            <div className="buttonIcon">
              {props.icon()}
            </div>
            
        </Button>
    )
}
*/